import styled from "styled-components";

export const Titulo = styled.h5`
text-align: center;
`;

export const Buscar = styled.input`
  border-radius: 10px;
`;

export const Boton = styled.button`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  outline: none;
`;

export const Herramientas = styled.div`
  display: flex;
  justify-content: center;
  //flex-direction: row;
  margin: 4px;
  padding: 10px;
  gap: 20px;
`;
